<div class="wallet-wrapper">
  <div class="row">
    <div class="col">
      <fx-page-header
        title="Wallet"
      ></fx-page-header>
    </div>
  </div>
  <!--<div class="row">-->
    <!--<div class="col">-->
      <!--<fx-transaction-->
        <!--type="banking"-->
        <!--[permission]="permission"></fx-transaction>-->
    <!--</div>-->
  <!--</div>-->
  <div class="row mb-3">
    <div class="col">
      <fx-request
        type="sticpay-transactions"
        [permission]="permission"
      ></fx-request>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      <fx-request
        type="banking-deposits"
        [permission]="permission"
      ></fx-request>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      <fx-request
        type="bitgo-deposits"
        [permission]="permission"
      ></fx-request>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      <fx-request
        type="banking-withdraws"
        [permission]="permission"></fx-request>
    </div>
  </div>
   <div class="row">
    <div class="col">
      <fx-manual-deposit type="manual-deposit-withdraw"></fx-manual-deposit>
    </div>
  </div>
</div>
